var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-grid-vue',_vm._b({ref:"agChecadas",staticClass:"ag-theme-alpine",staticStyle:{"height":"65vh"},attrs:{"id":"agChecadas"},on:{"grid-ready":_vm.onGridReady,"filterChanged":_vm.onFilterChanged}},'ag-grid-vue',_vm.agChecadas,false))}
var staticRenderFns = []

export { render, staticRenderFns }